import { PresentationRecord } from './types';

export function coverCacheKey(item: Pick<PresentationRecord, '_id' | 'coverSlideId' | 'updatedAt'>): string | null {
  if (!item.coverSlideId) return null;
  return `${item._id}:${item.coverSlideId}:${item.updatedAt || ''}`;
}
